import { render, staticRenderFns } from "./creance-patients.html?vue&type=template&id=70b6f0d8&scoped=true&external"
import script from "./creance-patients.js?vue&type=script&lang=js&external"
export * from "./creance-patients.js?vue&type=script&lang=js&external"
import style0 from "./creance-patients.scss?vue&type=style&index=0&id=70b6f0d8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b6f0d8",
  null
  
)

export default component.exports